import React from "react";
import { numberWithSpaces } from "../../utils";

export default class WalletBalance extends React.PureComponent {
  render() {
    const { currency, balance } = this.props;
    return (
      <div className="wallet-balance">
        <span className="wallet-balance__title">Баланс {currency}</span>
        <span className="wallet-balance__value">
          {numberWithSpaces(balance)}
          {" "}
          <span>{currency}</span>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Wallet/WalletBalance.jsx